import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import {showhtml} from  'utils/methods'
require("./index.scss");


export default class platformInfo extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      navNum: '',
      active: 0,
      type:1,
      current:1,
      size:10,
      data:'',
    };
  }

  componentDidMount() {
      this.getList()
  }

getList(){
  let { type,current,size} = this.state;
    let params = {
      type:type,
    };
  return Http.get(Request.aboutUs(), params, obj => {
      console.log('obj', obj.data);
      if (obj.code == 200) {
        this.setState({
          data:obj.data
        })
      } else {
       
      }
  });
   }





  render() {
    const { data } = this.state;
    return (
        <div className="details">
        <div>
            <div className="details_title">{data.title}</div>
            <div className="details_conts details_conts_us">
            {showhtml(data.content)}
          </div>
        </div>
      </div>
    );
  }
}
